import { Box, Grid, Typography } from "@mui/material"
import { RoundSchedule } from "../domain/election"

interface DisplayScheduleProps {
    schedule: RoundSchedule
}

export const DisplaySchedule = ({ schedule }: DisplayScheduleProps) => {
    const { open_at_text, close_at_text } = schedule;

    return (
        <Grid container>
            <Grid item xs={6}>
                <Typography variant="caption">
                    Opens:
                </Typography>
                {open_at_text ? (
                    <Typography>
                        {open_at_text}
                    </Typography>
                ) : null}
            </Grid>
            <Grid item xs={6}>
                <Typography variant="caption">
                    Closes:
                </Typography>
                {close_at_text ? (
                    <Typography>
                        {close_at_text}
                    </Typography>
                ) : null}
            </Grid>
        </Grid>
    )
}